  <div class="modal-header">
    <h4 class="modal-title"> {{'selectProjectReportPopup.title' | translate}}</h4>
  </div>

  <div class="modal-body pt-0">
    <div class="modal-body-inner overflow-xh" maxHeightOffset style="min-height: 150px">

      <table class="table table-sm table-borderless fixed-layout table-header">
        <thead>
        <tr>
          <th class="w-50">{{'selectProjectReportPopup.template.name' | translate}}</th>
        </tr>
        </thead>
      </table>
      <table class="table table-sm table-borderless fixed-layout mb-0 mt-1">
        <tbody>
        <tr *ngFor="let option of primaryCsvModeOptions">
          <td class="w-50 p-0">
            <div class="form-check">
              <input type="radio" [id]="option.id" [name]="option.name" [value]="option.value" [(ngModel)]="primaryCsvMode" (ngModelChange)="primaryChanged()" class="form-check-input">
              <label [for]="option.id" class="form-check-label">{{option.label | translate}}</label>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <hr class="mt-1">

      <div class="overflow-h">

        <div *ngIf="isByPosition" class="row">
          <div class="col-4"><label>{{'selectProjectReportPopup.label.csv_mode' | translate}}</label></div>
        </div>
        <div *ngIf="isByPosition" class="row pb-3">
          <div class="col-9">
            <div class="form-check" *ngFor="let option of secondaryCsvModeOptions">
              <input type="radio" [id]="option.id" [name]="option.name" [value]="option.value" [(ngModel)]="secondaryCsvMode" (ngModelChange)="secondaryChanged()" class="form-check-input">
              <label [for]="option.id" class="form-check-label">{{option.label | translate}}</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-5"><label>{{'selectProjectReportPopup.label.columns.visibility' | translate}}</label></div>
          <div class="col-4"><label>{{'selectProjectReportPopup.label.encodings' | translate}}</label></div>
          <div class="col-3" *ngIf="exportModel.multipleProjectReport && isGrouped"><label>{{'selectProjectReportPopup.label.report.mode' | translate}}</label></div>
        </div>
        <div class="row">
          <div class="col-5">
            <div *ngFor="let csvColumn of exportModel.csvColumnsList">
              <div *ngIf="csvColumn.visible" class="form-check checkbox">
                <input type="checkbox" class="form-check-input" id="{{csvColumn.label}}" [disabled]="csvColumn.disabled ? true : null" [(ngModel)]="csvColumn.selected" (change)="onReportsChange()">
                <label for="{{csvColumn.label}}" class="form-check-label">{{csvColumn.label | translate}}</label>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="form-check" *ngFor="let item of exportModel.encodingKeys">
              <input type="radio" class="form-check-input" name="encodings" [value]="item" [(ngModel)]="exportModel.encodinGroupSelected" [id]="item">
              <label class="form-check-label" [for]="item">{{item}}</label>
            </div>
          </div>
          <div class="col-3" *ngIf="exportModel.multipleProjectReport && isGrouped">
            <div class="form-check" *ngFor="let item of exportModel.dataStructureGroup">
              <input type="radio" class="form-check-input" name="mode" [value]="item" [disabled]="exportModel.dataStructureGroupDisabled ? true : null" [(ngModel)]="exportModel.dataStructureGroupSelected" [id]="item" (change)="dataStructureGroupChange(item)">
              <label class="form-check-label" [for]="item">{{item | translate}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-between">
    <div class="form-check checkbox me-auto">
      <input type="checkbox" class="form-check-input" id="saveSettings" [(ngModel)]="exportModel.saveSettings">
      <label for="saveSettings" class="form-check-label">{{'selectProjectReportPopup.properties.remember' | translate}}</label>
    </div>
    <button class="btn btn-secondary btn-cancel" type="button" (click)="close()">{{'global.label.cancel' | translate}}</button>
    <button class="btn btn-primary btn-forward" data-testid="select-csv-report-confirm" [disabled]="!exportModel.nextButtonEnabled" type="button" (click)="next()">{{'global.label.next' | translate}}</button>
  </div>
